import { TPlant } from '../../types';

export type TP_CoolingOutlet = {
    isOn: boolean;
    isMan: boolean;
    errSum: boolean;

    showCoil: boolean;
    showTrendPanels: boolean;
    showFlow: boolean;
    showOutlet: boolean;
    showEfficiency: boolean;
} & TPlant

export const schema = 'AutomationApps.Plants.Coolings.P_CoolingOutlet';
export const modelId = 'dtmi:AutomationApps:Plants:Coolings:P_CoolingOutlet';   
